import "./LoadingError.html";

import type { IControllerConstructor, Injectable } from "angular";
import { LoadingErrorComponentController } from "./LoadingErrorComponentController";

export class LoadingErrorComponent implements ng.IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            response: "=ngModel",
        };
        this.controller = LoadingErrorComponentController;
        this.templateUrl = "/App/Modules/Gui/Components/Indicators/LoadingError/LoadingError.html";
    }
}
